import React, { Component } from "react";
import { connect } from "react-redux";

import { updateSociete } from "../../store/actions/societeAction";

import FormSociete from "../../components/FormSociete";

import { toast } from "react-toastify";

class Personnes extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleEditSociete = (data, id, numClient) => {
    data.societe_num_client = numClient;
    this.props
      .updateSociete(data, id)
      .then((res) => {
        toast.success("Société éditée !", { containerId: "A" });
      })
      .catch((err) => {
        toast.error("Échec de l'édition !", { containerId: "A" });
      });
  };

  render() {
    const { societes, utilisateur } = this.props;

    return (
      <div>
        <FormSociete
          societe={societes.data.find((s) => s.societe_id === utilisateur.societe_id)}
          handleEdit={this.handleEditSociete}
          utilisateur={utilisateur}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateSociete: (jsonData, id) => dispatch(updateSociete(jsonData, id)),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    societes: state.societes,
    utilisateur: state.utilisateur.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Personnes);
